import {
  Button,
  FormControl,
  FormLabel,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Switch,
  SwitchProps,
  Text,
  useDisclosure,
} from '@elkaso-app/web-design';
import { useToggleBranchActivationApi } from 'apis/restaurants/use-toggle-branch-activation-api';
import { useParams } from 'react-router-dom';

export interface IBranchActivationSwitchCell extends SwitchProps {
  branchId: string;
  isActive: boolean;
}

export const BranchActivationSwitch = ({ branchId, isActive, ...rest }: IBranchActivationSwitchCell) => {
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate: toggleBranchActivation, isLoading: isToggleBranchLoading } =
    useToggleBranchActivationApi(restaurantId);

  const handleToggleActivation = () => {
    const variables = {
      branchId,
      body: {
        isActive: !isActive,
      },
    };

    toggleBranchActivation(variables, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  return (
    <>
      <FormControl display='flex' alignItems='center'>
        <Switch id={`active-branch-${branchId}`} onChange={onOpen} isChecked={isActive} {...rest} />
        <FormLabel
          htmlFor={`active-branch-${branchId}`}
          mb='0'
          ms='sm'
          userSelect='none'
          fontWeight='normal'
          fontSize='sm'>
          {isActive ? 'Active' : 'Inactive'}
        </FormLabel>
      </FormControl>

      <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{isActive ? 'Deactivate' : 'Activate'} branch!</ModalHeader>

          <ModalBody>
            {isActive && (
              <>
                <Text>Are you sure you want to deactivate this branch?</Text>
                <Text>This branch will be marked as inactive until it is activated again.</Text>
              </>
            )}

            {!isActive && (
              <>
                <Text>Are you sure you want to activate this branch?</Text>
                <Text>This branch will be marked as active after activation.</Text>
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <HStack spacing='md'>
              <Button variant='outline' colorScheme='red' onClick={onClose}>
                Cancel
              </Button>
              <Button
                variant='solid'
                colorScheme='red'
                onClick={handleToggleActivation}
                isLoading={isToggleBranchLoading}>
                {isActive ? 'Deactivate' : 'Activate'}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
